import { Link, useParams } from "react-router-dom";
import { ArrowLeft, BarChart3 } from "lucide-react";
import ClassAnalyticsView from "@/components/analytics/ClassAnalyticsView";

export default function ClassAnalytics() {
  const { id } = useParams();
  return (
    <div className="p-4 sm:p-6 md:p-8 max-w-7xl mx-auto" data-testid="class-analytics-page">
      <Link to="/classes" className="inline-flex items-center gap-1 text-sm text-[#6B655E] mb-4 hover:text-[#F75A1B]">
        <ArrowLeft className="w-4 h-4" /> Voltar para turmas
      </Link>
      <header className="mb-6 flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-[#6B655E] font-medium">Acompanhamento</p>
          <h1 className="font-display text-3xl md:text-4xl font-bold inline-flex items-center gap-2 mt-1"><BarChart3 className="w-7 h-7 text-[#F75A1B]" /> Análise completa da turma</h1>
          <p className="text-sm text-[#6B655E] mt-2">Resumo rápido no card; análise profunda aqui, com gráficos e drilldowns.</p>
        </div>
        <Link to={`/reports?class=${id}`} className="text-sm px-3 py-2 rounded-xl border border-[#E0D9CD] bg-white hover:border-[#F75A1B]/50">Abrir na Central de Relatórios</Link>
      </header>
      <ClassAnalyticsView classGroupId={id} />
    </div>
  );
}
